import { useQuery } from '@tanstack/react-query';
import { api } from '@/services/api';
import { useTenants } from '@/services/tenants/useTenants';
import { ASSET_POLL_INTERVAL_MS } from '@/hooks/useDataPolling/pollingConstants';

export const ASSET_FILE_TYPE_COUNTS_QUERY_KEY = 'assetFileTypeCounts';

export function useGetAssetFileTypeCounts({ pollWhileIndexing }: { pollWhileIndexing?: boolean } = {}) {
  const { getTenantId } = useTenants();
  const tenantId = getTenantId();

  return useQuery({
    queryKey: [ASSET_FILE_TYPE_COUNTS_QUERY_KEY, { tenantId }],
    queryFn: () => api.assets.getAssetFileTypeCounts({ tenantId }),
    select: data => data.data,
    enabled: !!tenantId,
    placeholderData: previousData => previousData,
    refetchOnMount: 'always',
    refetchOnWindowFocus: 'always',
    refetchInterval: pollWhileIndexing ? ASSET_POLL_INTERVAL_MS : false,
  });
}
